import { render, staticRenderFns } from "./wq_categories.vue?vue&type=template&id=55c1b2a8&scoped=true&"
import script from "./wq_categories.vue?vue&type=script&lang=js&"
export * from "./wq_categories.vue?vue&type=script&lang=js&"
import style0 from "./wq_categories.vue?vue&type=style&index=0&id=55c1b2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1b2a8",
  null
  
)

export default component.exports